import React, { useContext, useMemo } from 'react'
import {
  Box, Button, IcoMoon, Text, CloseIcon
} from '@usap/uicomponents'
import { SearchContext } from '../../common/context/SearchContextProvider'

export default function AccordionTitle() {
  const {
    searchState: { sidebarStatus },
    setSearchContext,
  } = useContext(SearchContext)

  const style = useMemo(
    () => (
      {
        border: { side: 'bottom', size: 'xsmall', color: 'grey' },
      }
    ),
    [],
  )

  return (
    <Box border={style.border}>
      <Box direction="row" justify="between" align="center" pad="medium">
        <Text weight="bold" color="dark-2">
          Filter results
        </Text>
        <Box round="full" overflow="hidden" id="closeSidebar">
          <Button
            icon={<IcoMoon icon={CloseIcon} color="dark-2" size="24px" />}
            hoverIndicator
            onClick={() => setSearchContext({ sidebarStatus: !sidebarStatus })}
          />
        </Box>
      </Box>
    </Box>
  )
}
